"use no memo";

function locationReplace(url: string): void {
  window.location.replace(url);
}

export default locationReplace;
